export default __webpack_public_path__ + "static/media/cover_libro.d9ffa781.png";